import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../../components/SeoHead';
import MainBanner from '../../../../components/MainBanner';
import AllConsultants from '../../../../components/AllConsultants';
import MultiColumnCTAWithDivider from '../../../../components/MultiColumnCTAWithDivider';

export default function MeetTheTeam({
    global,
    all_consultants
}) {
    return (
        <>
            <SeoHead
                page_name={`Meet the Lorien Team | Technology Specialists in the US`}
                description={`Meet the dedicated specialists behind Lorien, bringing deep experience and industry knowledge to support clients and candidates.`}
                canonical_link={`about-us/meet-the-team`}
                en_gb={false}
                en_us={true}
                
            />
            <MainBanner
                global={global}
                pathPrefix={`us.meet_the_team_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Meet the Team</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-about-us.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                breadcrumb_title="Meet The Team"
                secondary_breadcrumb_url={"/us/about-us"}
                secondary_breadcrumb_title={"About Us"}
            />
            <AllConsultants
                global={global}
                pathPrefix={`us.meet_the_team_page.all_consultants`}
                customClass={`py-5 grayGradientBg`}
                content={<>
                    <h2>Our Team</h2>
                </>}
                post={all_consultants}
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`us.meet_the_team_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Work for us</h2>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`Join us now`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const consultants = (await Collection('consultants'))
        .filter(function (post) {
            return (
                post.slt?.en === true
            );
        })
        .filter(function (post) {
            return (
                post.country?.en == "US"
            );
        })
    const all_consultants = consultants.orderBy('_order').getItems();

    return {
        props: {
            global,
            all_consultants
        }
    };
}
